(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dc-before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBA(root) {
    var after = root.querySelector('[data-dc-ba-after]');
    var handle = root.querySelector('[data-dc-ba-handle]');
    if (!after || !handle) return;
    var dragging = false;

    function setPos(clientX) {
      var rect = root.getBoundingClientRect();
      var pct = (clientX - rect.left) / rect.width * 100;
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    }

    function down(e) {
      dragging = true;
      root.setPointerCapture && e.pointerId != null && root.setPointerCapture(e.pointerId);
      setPos(e.clientX);
    }
    function move(e) {
      if (!dragging) return;
      e.preventDefault();
      setPos(e.clientX);
    }
    function up() { dragging = false; }

    if (window.PointerEvent) {
      root.addEventListener('pointerdown', down);
      root.addEventListener('pointermove', move);
      root.addEventListener('pointerup', up);
      root.addEventListener('pointercancel', up);
    } else {
      root.addEventListener('mousedown', function (e) { down(e); });
      window.addEventListener('mousemove', function (e) { if (dragging) setPos(e.clientX); });
      window.addEventListener('mouseup', up);
      root.addEventListener('touchstart', function (e) { dragging = true; setPos(e.touches[0].clientX); }, { passive: true });
      root.addEventListener('touchmove', function (e) { if (dragging) { setPos(e.touches[0].clientX); } }, { passive: true });
      window.addEventListener('touchend', up);
    }
  }

  function boot() {
    document.querySelectorAll('[data-dc-ba]').forEach(initBA);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot() {
    document.querySelectorAll('[data-dc-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sel.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    });
    initZones();
    initSearch();
  }

  function initZones() {
    document.querySelectorAll('[data-dc-ztoggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var g = btn.closest('[data-dc-zgroup]');
        if (!g) return;
        var sub = g.querySelector('[data-dc-zsub]');
        var open = g.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (sub) sub.hidden = !open;
      });
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function eur(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return '€' + n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function thumb(u) {
    if (!u) return '';
    var i = u.indexOf('?'), base = i > -1 ? u.slice(0, i) : u, qs = i > -1 ? u.slice(i) : '';
    base = base.replace(/\.(jpg|jpeg|png|webp|gif)$/i, function (m, ext) { return '_120x90.' + ext; });
    return base + qs;
  }

  // --- Drago Carbon supplier-code guard (v3, 2026-09-14) -------------------------------------
  // Shopify's suggest API can still return a product whose *variant SKU* matches the query, even
  // though variants.sku is not in the fields list. Suggestions are therefore checked here as well:
  // a product is dropped when any query token matches its hidden SKU/barcode (or has the shape of a
  // supplier part number) and does not appear in the customer-visible text (title, type, vendor,
  // tags, description). Variant SKUs themselves are never changed or displayed.
  var DC_CHASSIS = ',e36,e39,e46,e60,e61,e63,e64,e70,e71,e81,e82,e87,e88,e89,e8x,e90,e91,e92,e93,e9x,f06,f07,f10,f11,f12,f13,f15,f16,f18,f20,f21,f22,f23,f25,f26,f30,f31,f32,f33,f34,f35,f36,f40,f44,f48,f52,f80,f82,f83,f85,f86,f87,f8x,f90,f91,f92,f93,f95,f96,f97,f98,f9x,g01,g02,g05,g06,g07,g08,g09,g11,g12,g14,g15,g16,g20,g21,g22,g23,g26,g28,g29,g30,g31,g32,g38,g42,g45,g60,g61,g70,g80,g81,g82,g83,g87,g8x,g90,g99,i01,i12,i4,u10,';
  function dcCompact(s) { return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function dcSuspect(t) {
    if (DC_CHASSIS.indexOf(',' + t + ',') > -1) return false;
    if (/sportline|jcsport/.test(t)) return true;
    if (/^(jc|ml|jp|ed)-/.test(t)) return true;
    if (/^[a-z]{1,4}[0-9]{2,}$/.test(t)) return true;
    if (/^[0-9]{4,}$/.test(t)) return true;
    return false;
  }
  function dcLeaksCode(q, p) {
    var vis = ' ' + String((p.title || '') + ' ' + (p.type || '') + ' ' + (p.vendor || '') + ' '
      + (p.tags || []).join(' ') + ' ' + String(p.body || '').replace(/<[^>]*>/g, ' '))
      .toLowerCase().replace(/[^a-z0-9]+/g, ' ') + ' ';
    var codes = '|';
    (p.variants || []).forEach(function (v) {
      codes += dcCompact(v.sku) + '|' + dcCompact(v.barcode) + '|';
    });
    var toks = String(q).toLowerCase().split(/[\s,\/_]+/);
    for (var i = 0; i < toks.length; i++) {
      var t = toks[i].replace(/^[^a-z0-9]+|[^a-z0-9]+$/g, '');
      if (!t) continue;
      var c = dcCompact(t);
      var visible = vis.indexOf(t) > -1 || (c.length > 1 && vis.indexOf(c) > -1);
      if (visible) continue;
      if (c.length > 1 && codes.indexOf(c) > -1 && codes !== '|') return true;
      if (dcSuspect(t)) return true;
    }
    return false;
  }

  function initSearch() {
    var form = document.querySelector('[data-dc-search]');
    if (!form) return;
    var input = form.querySelector('[data-dc-search-input]');
    var panel = form.querySelector('[data-dc-search-panel]');
    var timer, previewId = null;
    try { previewId = new URL(location.href).searchParams.get('preview_theme_id'); } catch (e) {}
    function withPreview(url) {
      if (!previewId) return url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + encodeURIComponent(previewId);
    }
    function allUrl(q) {
      return withPreview(form.getAttribute('action') + '?type=product&q=' + encodeURIComponent(q));
    }
    function render(q, products) {
      var html = '';
      if (!products.length) {
        html = '<div class="dc-col__search-empty">No parts match “' + esc(q) + '”.</div>';
      } else {
        products.forEach(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          html += '<a class="dc-col__search-row" href="' + withPreview(p.url) + '">'
            + (img ? '<img loading="lazy" src="' + esc(thumb(img)) + '" alt="" width="42" height="32">' : '<span class="dc-col__search-noimg"></span>')
            + '<span class="dc-col__search-info"><span class="dc-col__search-t">' + esc(p.title) + '</span>'
            + '<span class="dc-col__search-p">' + eur(p.price) + '</span></span></a>';
        });
      }
      html += '<a class="dc-col__search-all" href="' + allUrl(q) + '">See all results for “' + esc(q) + '” →</a>';
      panel.innerHTML = html;
      panel.hidden = false;
    }
    function queryFor(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product&resources[limit]=7'
        + '&resources[options][unavailable_products]=last'
        // Search these fields only. 'tag' + 'body' make style terms (e.g. CSL, PSM) findable;
        // variants.sku / variants.barcode are deliberately NOT listed; results are additionally checked by dcLeaksCode().
        + '&resources[options][fields]=title,product_type,variants.title,vendor,tag,body';
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return;
        if (input.value.trim() !== q) return;
        var prods = [];
        try { prods = JSON.parse(xhr.responseText).resources.results.products || []; } catch (e) {}
        prods = prods.filter(function (p) { return !dcLeaksCode(q, p); });
        render(q, prods);
      };
      xhr.send();
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { panel.hidden = true; return; }
      timer = setTimeout(function () { queryFor(q); }, 180);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && panel.innerHTML) panel.hidden = false;
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { panel.hidden = true; }
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) panel.hidden = true;
    });
    form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q) { e.preventDefault(); return; }
      if (previewId) { e.preventDefault(); location.href = allUrl(q); }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-configurator"] && !Shopify.designMode) return;
  try {
    
(function () {
  function escAttr(s) { return String(s == null ? '' : s).replace(/"/g, '&quot;'); }

  function initConfigurator(root) {
    var dataEl = root.querySelector('.dc-cfg-data');
    var bar = root.querySelector('.dc-cfg__bar');
    var stage = root.querySelector('.dc-cfg__stage');
    var stepEl = root.querySelector('.dc-cfg__step');
    if (!dataEl || !bar || !stage) return;
    function setStep(html) { if (stepEl) stepEl.innerHTML = html; }

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var brands = data.brands || [];
    var state = { brand: null, model: null, gen: null, zone: null };

    function slugify(s) { return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function handleFor(brand, model, gen) {
      if (!brand || !model || !gen) return '';
      var b = brand.slug || slugify(brand.name);
      var m = slugify(model.id || model.name);
      var g = gen.slug || slugify(gen.code);
      if (!b || !m || !g) return '';
      return b + '-' + m + '-' + g;
    }
    function scrollCustom() {
      var c = document.getElementById('custom');
      if (c) {
        var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        c.scrollIntoView({ behavior: rm ? 'auto' : 'smooth' });
      } else { location.hash = 'custom'; }
    }
    // After a step change the new grid can be much shorter than the old one
    // (e.g. Z4 in the bottom row of 30 BMW models -> tiny chassis grid). The
    // browser keeps the old scroll offset on the shrunken page, dumping the
    // user below the picker. If the picker's top scrolled out of view, snap
    // back to it (just under the sticky header).
    function snapTop() {
      var hdr = document.querySelector('.dc-hd');
      var off = (hdr ? hdr.offsetHeight : 0) + 10;
      var top = root.getBoundingClientRect().top;
      if (top >= off) return;
      window.scrollTo(0, Math.max(window.scrollY + top - off, 0));
    }
    // Picking a chassis opens that car's full parts grid; Interior/Exterior and
    // product-type filters live in the grid sidebar, so no zone step here.
    function goChassis() {
      var h = handleFor(state.brand, state.model, state.gen);
      if (!h) { scrollCustom(); return; }
      window.location.href = '/collections/' + h;
    }

    function renderBar() {
      bar.innerHTML = '';
      if (!state.brand) {
        setStep('Step <b>1</b> of 3 — Select brand');
        return;
      }
      if (state.brand.soon) { setStep(''); }
      else if (state.model) { setStep('Step <b>3</b> of 3 — Select chassis'); }
      else { setStep('Step <b>2</b> of 3 — Select model'); }
      var crumb = document.createElement('div');
      crumb.className = 'dc-cfg__crumb';
      var html = '<b>' + state.brand.name + '</b>';
      if (state.model) { html += '<span class="dc-sep">/</span><b>' + state.model.name + '</b>'; }
      crumb.innerHTML = html;
      bar.appendChild(crumb);
      var btn = document.createElement('button');
      btn.className = 'dc-cfg__back';
      btn.type = 'button';
      btn.innerHTML = '← Back';
      btn.addEventListener('click', function () {
        if (state.model) { state.model = null; renderModels(); }
        else { state.brand = null; renderBrands(); }
        snapTop();
      });
      bar.appendChild(btn);
    }

    function renderBrands() {
      state.brand = null;
      state.model = null;
      state.gen = null;
      state.zone = null;
      renderBar();
      stage.innerHTML = '';
      var grid = document.createElement('div');
      grid.className = 'dc-brand-grid dc-cfg-fade';
      brands.forEach(function (b) {
        var card = document.createElement('button');
        card.className = 'dc-brand';
        card.type = 'button';
        var img = b.logo ? '<img src="' + escAttr(b.logo) + '" alt="' + escAttr(b.name) + ' carbon fiber parts" width="240" height="240" loading="lazy">' : '';
        var count = b.models ? (b.models.length + (b.models.length === 1 ? ' model' : ' models')) : 'Coming soon';
        card.innerHTML = '<div class="dc-brand__logo">' + img + '</div><div class="dc-brand__name">' + b.name + '</div><div class="dc-brand__count">' + count + '</div>';
        card.addEventListener('click', function () {
          state.brand = b;
          if (b.soon) { renderBrandSoon(); } else { renderModels(); }
          snapTop();
        });
        grid.appendChild(card);
      });
      stage.appendChild(grid);
    }

    function renderBrandSoon() {
      renderBar();
      stage.innerHTML = '';
      var brand = state.brand.name;
      var d = document.createElement('div');
      d.className = 'dc-cfg__empty dc-cfg__empty--cta dc-cfg-fade';
      d.innerHTML =
        '<h2 class="dc-cfg__empty-h">Looking for carbon parts for your ' + brand + '?</h2>' +
        '<p class="dc-cfg__empty-p">Our full online catalogue for this brand isn\u2019t live yet, but we produce a wide range of carbon fibre parts for your car. Tell us what you\u2019re looking for and we\u2019ll prepare a custom offer for your exact model.</p>' +
        '<div class="dc-cfg__empty-btns">' +
          '<a class="dc-btn dc-cfg__empty-cta" href="/?car=' + encodeURIComponent(brand) + '#custom">Request Carbon Parts for This Car</a>' +
          '<a class="dc-btn dc-cfg__empty-ig" href="https://www.instagram.com/dragocarbon/" target="_blank" rel="noopener">Message Us on Instagram</a>' +
        '</div>';
      stage.appendChild(d);
    }

    function renderModels() {
      state.model = null;
      state.gen = null;
      state.zone = null;
      renderBar();
      stage.innerHTML = '';
      var grid = document.createElement('div');
      grid.className = 'dc-veh-grid dc-cfg-fade';
      (state.brand.models || []).forEach(function (m) {
        var card = document.createElement('button');
        card.className = 'dc-veh';
        card.type = 'button';
        var imgHtml = m.img ? '<img src="' + escAttr(m.img) + '" alt="' + escAttr(m.name) + '" loading="lazy">' : '';
        card.innerHTML = '<div class="dc-veh__ph">' + imgHtml + '</div>' +
          '<div class="dc-veh__meta"><span class="dc-veh__name">' + m.name + '</span><span class="dc-veh__yr">' + m.years + '</span></div>';
        card.addEventListener('click', function () { state.model = m; renderGen(); snapTop(); });
        grid.appendChild(card);
      });
      stage.appendChild(grid);
    }

    function renderGen() {
      state.gen = null;
      state.zone = null;
      renderBar();
      stage.innerHTML = '';
      var grid = document.createElement('div');
      grid.className = 'dc-gen-grid dc-cfg-fade';
      (state.model.gens || []).forEach(function (g) {
        var card = document.createElement('button');
        card.className = 'dc-gen';
        card.type = 'button';
        var imgHtml = g.img ? '<img src="' + escAttr(g.img) + '" alt="' + escAttr(state.model.name + ' ' + g.code) + '" loading="lazy">' : '';
        card.innerHTML = '<div class="dc-gen__ph">' + imgHtml + '</div>' +
          '<div class="dc-gen__meta">' +
          '<span class="dc-gen__code">' + g.code + '</span>' +
          '<div class="dc-gen__name">' + g.name + '</div>' +
          '<div class="dc-gen__years">' + g.years + '</div></div>';
        card.addEventListener('click', function () { state.gen = g; goChassis(); });
        grid.appendChild(card);
      });
      stage.appendChild(grid);
    }

    renderBrands();
  }

  function boot() {
    document.querySelectorAll('[data-dc-configurator]').forEach(initConfigurator);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-custom-order"] && !Shopify.designMode) return;
  try {
    
(function() {
  var chips = document.querySelectorAll('.dc-weave-chip');
  chips.forEach(function(chip) {
    chip.addEventListener('click', function() {
      chips.forEach(function(c) { c.classList.remove('dc-weave-chip--sel'); });
      chip.classList.add('dc-weave-chip--sel');
    });
  });
  /* Pre-fill the Car field from a ?car= param (set by the empty-state / Coming Soon CTAs) */
  try {
    var car = new URLSearchParams(window.location.search).get('car');
    if (car) {
      var f = document.querySelector('.dc-custom input[name="contact[body_car]"]');
      if (f && !f.value) f.value = car;
    }
  } catch (e) {}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initHero(stage) {
    var sheen = stage.querySelector('[data-dc-hero-sheen]');
    if (!sheen) return;
    var hero = stage.closest('.dc-hero') || stage;
    hero.addEventListener('mousemove', function(e) {
      var r = hero.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width * 100).toFixed(1);
      var y = ((e.clientY - r.top) / r.height * 100).toFixed(1);
      sheen.style.background = 'radial-gradient(520px 520px at ' + x + '% ' + y + '%, rgba(82,180,255,.10), transparent 64%)';
    });
  }
  function boot() {
    document.querySelectorAll('[data-dc-hero-bg]').forEach(initHero);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPdp(root) {
    var main = root.querySelector('[data-pdp-mainimg]');
    if (!main) return;
    var thumbs = [].slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    var countEl = root.querySelector('[data-pdp-count]');
    var i = 0;
    var total = thumbs.length || 1;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function show(n) {
      if (!thumbs.length) return;
      i = (n + thumbs.length) % thumbs.length;
      var full = thumbs[i].getAttribute('data-full');
      main.style.opacity = '0';
      var pre = new Image();
      pre.onload = function () { main.src = full; main.style.opacity = '1'; };
      pre.src = full;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      if (countEl) countEl.textContent = pad(i + 1) + ' / ' + pad(total);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var nx = root.querySelector('[data-pdp-next]'), pv = root.querySelector('[data-pdp-prev]');
    if (nx) nx.addEventListener('click', function () { show(i + 1); });
    if (pv) pv.addEventListener('click', function () { show(i - 1); });

    var mainBox = root.querySelector('[data-pdp-main]');
    var lb = document.createElement('div');
    lb.className = 'dc-pdp__lightbox';
    lb.innerHTML = '<img alt="">';
    document.body.appendChild(lb);
    if (mainBox) mainBox.addEventListener('click', function (e) {
      if (e.target.closest('[data-pdp-prev],[data-pdp-next]')) return;
      lb.querySelector('img').src = main.src; lb.classList.add('is-open');
    });
    lb.addEventListener('click', function () { lb.classList.remove('is-open'); });

    var q = root.querySelector('[data-pdp-qty]');
    var plus = root.querySelector('[data-pdp-plus]'), minus = root.querySelector('[data-pdp-minus]');
    if (plus) plus.addEventListener('click', function () { q.value = (parseInt(q.value, 10) || 1) + 1; });
    if (minus) minus.addEventListener('click', function () { q.value = Math.max(1, (parseInt(q.value, 10) || 1) - 1); });
  }
  function boot() { document.querySelectorAll('[data-dc-pdp]').forEach(initPdp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-rail"] && !Shopify.designMode) return;
  try {
    
(function () {
  var rail = document.querySelector('[data-dc-rail]');
  if (!rail) return;
  var links = rail.querySelectorAll('[data-dc-rail-link]');

  function setActive(id) {
    links.forEach(function (a) {
      a.classList.toggle('dc-on', a.getAttribute('data-dc-rail-link') === id);
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) setActive(en.target.id);
    });
  }, { rootMargin: '-45% 0px -45% 0px' });

  links.forEach(function (a) {
    var el = document.getElementById(a.getAttribute('data-dc-rail-link'));
    if (el) io.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
